export const validateCanonical = (canonicalUrl: string, asPath?: string) => {
  if (canonicalUrl) {
    return canonicalUrl
  }

  const [protocol, host] = (process.env.NEXT_PUBLIC_URL_BASE || '').split('://')
  const path = asPath || ''

  if (host?.includes('www.')) {
    canonicalUrl = `${protocol}://${host}${path}`
  } else {
    canonicalUrl = `${protocol}://www.${host}${path}`
  }

  return canonicalUrl
}
